module.exports = __webpack_public_path__ + "img/1-ilpakamaniPRENSA.ab93b19f.jpg";